import { faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './NoConversation.css'

const NoConversation = () => {
    return (
        <div className="no-conversation">
            <FontAwesomeIcon icon={faComment} />
            <h2>Select a Conversation</h2>
        </div>
    )
};

export default NoConversation;
